import React, { useMemo, useState } from 'react';
import { Redirect } from 'react-router-dom';
import NCRDialog from '../../shared/components/ncr-dialog/NCRDialog';

const LAST_NON_QUALITY_ROUTE_KEY = 'bedrock.lastNonQualityRoute';

const getReturnTo = () => {
  try {
    const saved = sessionStorage.getItem(LAST_NON_QUALITY_ROUTE_KEY);
    if (saved && saved.trim()) return saved;
  } catch (e) {
    // ignore
  }
  return '/timesheet';
};

const NCRFormPage = ({ match, location }) => {
  const [showDialog, setShowDialog] = useState(true);
  const [redirectToThankYou, setRedirectToThankYou] = useState(false);
  const [submitInfo, setSubmitInfo] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  // Get the tab from URL params, default to 'ncr'
  const tab = match?.params?.tab || 'ncr';
  const returnTo = useMemo(() => getReturnTo(), []);

  const handleClose = (opts = {}) => {
    // Some callers may pass an event object; normalize to an options bag.
    const normalizedOpts =
      opts && (typeof opts.preventDefault === 'function' || typeof opts.stopPropagation === 'function')
        ? {}
        : (opts || {});

    setShowDialog(false);
    setSubmitted(!!normalizedOpts.submitted);
    setRedirectToThankYou(true);
  };

  const handleSubmitSuccess = (data) => {
    setSubmitInfo(data);
  };

  if (redirectToThankYou) {
    const info = submitInfo || {activeTab: tab, formType: 'Quality Issue'};
    const activeTab = info.activeTab || tab;
    return (
      <Redirect
        to={{
          pathname: '/quality-issue-form/thank-you',
          search: location?.search || '',
          state: {
            returnTo,
            submitted,
            ...info,
            activeTab
          },
        }}
      />
    );
  }

  return (
    <div className="ncr-form-page">
      {showDialog && (
        <NCRDialog
          heading="Non Conformance Entry."
          onClose={handleClose}
          onSubmitSuccess={handleSubmitSuccess}
          initialTab={tab}
        />
      )}
    </div>
  );
};

export default NCRFormPage;
